<template>
  <SSection
    :desktop-full="true"
    :title="t('views.cottage.registerNumber.title')"
  >
    <TProse :responsive="false" :clear="false">
      <ul>
        <li>
          {{ t('views.cottage.registerNumber.text1') }}
        </li>
        <li
          v-if="item.salesService.isOnlineBookingActive && item.owner.legalName"
        >
          {{
            t('views.cottage.registerNumber.text4', {
              name: item.owner.legalName,
            })
          }}
        </li>
        <li>
          {{ t('views.cottage.registerNumber.text2') }}
          {{
            item.tourismRegistrationNumber
              ? item.tourismRegistrationNumber
              : t('views.cottage.registerNumber.text3')
          }}
        </li>

        <li v-if="item.registrationNumbers && item.registrationNumbers.length">
          <span>{{ t('views.cottage.singlePropertyRegister.text') }}</span>
          <span v-for="(regNumber, key) in item.registrationNumbers" :key="key">
            <span v-if="key > 0">{{
              t('views.cottage.singlePropertyRegister.separator')
            }}</span>
            {{
              t('views.cottage.singlePropertyRegister.property', {
                name: regNumber.name,
                number: regNumber.number,
              })
            }}
          </span>
        </li>
      </ul>
    </TProse>
  </SSection>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'

type itemType = Pick<CottagePage, 'tourismRegistrationNumber'> & {
  owner: Pick<CottagePage['owner'], 'legalName'>
} & {
  salesService: Pick<CottagePage['salesService'], 'isOnlineBookingActive'>
} & {
  registrationNumbers?: CottagePage['registrationNumbers']
}

interface propsInterface {
  item: itemType
}

defineProps<propsInterface>()
</script>
